import { useMemo } from 'react';

import { useMyCareerProfileQuery } from 'core';
import { ICareerProfileData, transformCareerProfile } from './transform';

/**
 * Reads the student's career profile (spec 0018, increment B).
 *
 * `myCareerProfile` is created on first read and is open to ANY student
 * (self-only) — the section route stays reachable without a CareerMember.
 */
export const useCareerProfile = (): {
  profile: ICareerProfileData | null;
  loading: boolean;
  error?: string;
  refetch: () => void;
} => {
  const { data, loading, error, refetch } = useMyCareerProfileQuery({
    fetchPolicy: 'cache-and-network',
  });

  const profile = useMemo(() => transformCareerProfile(data), [data]);

  return { profile, loading, error: error?.message, refetch };
};
